import { useEffect, useState } from 'react';
import backet from '../../../../assets/media/icons/icon_delete.svg';
import plus from '../../../../assets/media/icons/plus.svg';
import styles from './styles.module.scss';

import Row from '../../../Basic/Blocks/Row';
import Button from '../../../Basic/Buttons/Button';
import DropDown from '../../../Basic/Elements/DropDown';
import Icon from '../../../Basic/Elements/Icon';
import Input from '../../../Basic/Inputs/Base';
import Text from '../../../Basic/WrapsStyle/Text';
import TextGrey from '../../../Basic/WrapsStyle/TextGrey';

const BarcodesBlock = ({ barcodes = [], label = '', readOnly = false, onAdd = (_) => _, onRemove = (_) => _ }) => {
  const [str, setStr] = useState('');
  const [settings, setSettings] = useState(false);
  const [newBarcode, setNewBarcode] = useState('');

  const addBarcode = async () => {
    if (newBarcode.length > 0) {
      await onAdd(newBarcode).then(() => {
        setNewBarcode('');
        setSettings(false);
      });
    }
  };

  const removeBarcode = async (barcode) => {
    await onRemove(barcode).then(() => {});
    setSettings(false);
  };

  useEffect(() => {
    setStr(barcodes.join(', '));
  }, [barcodes]);
  return (
    <Row style={{ width: '100%' }}>
      <div onClick={() => setSettings(true)} style={{ position: 'relative', width: '100%' }}>
        <Input value={str} readOnly styles={styles.on_hover} label={label} />
        {settings && (
          <div>
            <DropDown close={() => setSettings(false)} styles={styles.drop_down}>
              <div>
                {barcodes.map((b, key) => {
                  return (
                    <Row key={b} style={{ marginBottom: '12px' }}>
                      <Text styles={styles.text}>
                        <TextGrey fontSize={14}>
                          {key + 1}
                          {'. '}
                        </TextGrey>{' '}
                        {b}
                      </Text>
                      {!readOnly && (
                        <Button onClick={() => removeBarcode(b)}>
                          <Icon src={backet} height={'18px'} style={{ marginBottom: '3px' }} />
                        </Button>
                      )}
                    </Row>
                  );
                })}

                {!readOnly && (
                  <Row>
                    <Input placeholder="Новый штрихкод" value={newBarcode} onChange={(v) => setNewBarcode(v)} />
                    <Button onClick={() => addBarcode()} disabled={newBarcode.length === 0}>
                      <Icon src={plus} height={'17px'} style={{ marginLeft: '10px' }} />
                    </Button>
                  </Row>
                )}
              </div>
            </DropDown>
          </div>
        )}
      </div>
    </Row>
  );
};

export default BarcodesBlock;
